export const buildSubscriptionPayload = (data) => {
  const discountedUnitPrice = Number(data.unitPriceAfter ?? data.unitPrice);
  const discountAmount = Number(data.discountAmount || 0);
  const discountPercentage = Number(data.discount || 0);
  const payload = {
    plan: data.plan,
    numberOfUsers: data.pricingModel === 'PER_UNIT' ? Number(data.numberOfUsers) : 1,
    unitPrice: discountedUnitPrice,
    type: 'SUBSCRIPTION',
    country: data.country,
    periodUnit: data.periodUnit,
    addonSubscriptions: data?.addonSubscriptions?.map((item) => ({
      ...item,
      country: data.country,
      periodUnit: data.periodUnit,
    })),
  };

  if (discountAmount > 0) {
    payload.discount = discountAmount;
    payload.discountPercentage = discountPercentage;
    if (data.unitPriceBeforeDiscount) {
      payload.originalUnitPrice = Number(data.unitPriceBeforeDiscount);
    }
  }

  return payload;
};
